<style lang="less" scoped>
.kyteam{position: relative;width: 100%;display: flex;margin-bottom: 20px;}
.content{display: flex;flex-direction: column; justify-content: center;width: 1200px; margin: auto;}
.imgbox{margin-bottom: 40px;}
p{font-family: MicrosoftYaHei; font-size: 20px;text-align: left;margin: 10px auto;text-indent: 2em;line-height: 40px;}
ul{list-style: none;}
.number{display: flex;margin: 30px auto;}
.photo{width:260px;height: 260px;margin: 50px 80px;}
.number:nth-child(odd){flex-direction: row;}
.number:nth-child(even){flex-direction: row-reverse;}
.main{width: 600px;}
.name, .description{font-weight: 600;}
.chenghao{text-align: left;margin: 10px 0px;margin-left: 42px;}
</style>

<template>
  <div class="kyteam">
    <div class="content">
      <img src="static/images/官网首页/地学中心团队/team.jpg" style="width: 1200px; height: 360px;margin: 20px auto;" />
      <img src="static/images/官网首页/地学中心团队/law_ITLT.png" style="width: 1200px;height: 50px;margin: 50px auto;" />
      <div class="imgbox">
        <p>中国—东盟地学合作中心东盟矿业发展研究团队目前由35名具有丰富的国内外矿业勘查开发和管理经验的专家组成，其中博士2人、硕士及研究生16人，教授级高级工程师2人，高级工程师15人，研究领域主要涉及基础地质调查、地球物理调查、矿产勘查、矿业开发等领域，曾在铝土矿、锰矿、铅锌矿、锡矿勘查成果评比中荣获国内行业高级别奖项多项。</p>
        <p>该研究团队按国别设立相应的研究岗位，具有扎实的地学理论基础和全面的专业知识，特别是在东盟国家矿业勘查开发合作有较丰富的实战经验，掌握所研究国家的重要成矿区地质特征、成矿规律、找矿潜力及资源分布等信息，了解所研究国家的政治氛围、法律制度、矿业开发政策、宗教信仰、风土人情和民族禁忌等，熟练使用矿业专业英语或至少一门东盟国家小语种，能够在东盟矿业勘查开发领域提供全方位、高质量的精准服务。</p>
      </div>
      <ul>
        <li class="number" v-for="(item,index) in lawyerList" :key="index">
          <img class="photo" :src="item.pic" />
          <div class="main">
            <img src="static/images/官网首页/东盟法律咨询/ic_shape.png" style="margin-left: -450px;" />
            <p class="name">{{ item.name }}</p>
            <p class="description">{{ item.description }}</p>
            <li class="chenghao" v-for="(citem,cindex) in item.introduce" :key="cindex">{{ citem }}
            </li>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data()
  {
    return {
      lawyerList: [
        {
          name: '李水如',
          pic: 'static/images/官网首页/地学中心团队/李水如.jpg',
          description: '首席矿业研究专家',
          introduce: [
            '教授级高级工程师',
            '中国-东盟地学合作中心（南宁）副主任',
            '中国地质调查局非能源矿产技术专家',
            '广西自然资源厅地质矿产储量评审专家',
            '广西绿色矿山技术专家',
            '广西科技专家库专家',
            '荣获国土资源部“青年科技骨干”称号、“优秀地质找矿项目一等奖”、“全国矿产资源利用现状调查突出贡献奖”、“国土资源科学技术二等奖”',
            '获中国有色金属工业协会“找矿成果二等奖”三项、“找矿成果三等奖”一项'
          ]
        },
        {
          name: '黎海龙',
          pic: 'static/images/官网首页/地学中心团队/黎海龙.jpg',
          description: '首席地球物理研究专家',
          introduce: [
            '教授级高级工程师，工学博士',
            '中国—东盟地学合作中心（南宁）副主任',
            '中国注册地球物理工程师',
            '中国地质调查局地质调查项目技术专家',
            '广西自然资源厅地质矿产储量评审专家',
            '广西科技专家库专家',
            '中国地球物理学会金属矿勘查委员会委员',
            '荣获自然资源部科学技术一等奖一项',
            '中国有色工业协会找矿成果二等奖一项',
            '厅局级勘查成果奖多项',
            '目前正开展利用卫星重磁信息探讨东特提斯构造域演化机制及其区域成矿规律方面的研究'
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/DXZXteam.vue